var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.appCssClass,attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('ui-spinner',{attrs:{"loading":_vm.isLoading}}),_c('language-translation-warn-dialog',{ref:"theLanguageWarningDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }